import React from "react";
import banner from "../assets/images/people.webp";
import FormComponent from "./form-component";

const BannerComponent = () => {
  return (
    <>
      <section className="banner pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-12 pos-rel">
              <div className="bnrcontent">
                <h1>Probationary Officer Program </h1>
                <h2 style={{ color: "#94292E" }}>
                  Aspire to be a Relationship Manager
                </h2>
                <ul>
                  <li>Customer engagement <br/>roles across India</li>
                </ul>
                <ul>
                  <li>Fully sponsored 2-month <br/>residential training</li>
                </ul>
                <ul>
                  <li>CTC from ₹5.0 Lakh to <br/>₹5.5 Lakh</li>
                </ul>
              </div>
              <img
                src={banner}
                alt="banner img"
                className="desktop_men"
                width="452"
                height="548"
              />

            </div>
            <div className="col-lg-5  col-md-12">
              <FormComponent></FormComponent>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BannerComponent;
